import { ICONS } from '@client/constants/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/coi')({
    staticData: {
        breadcrumb: {
            title: 'Conflict of interest',
        },
        roles: ['user', 'shared_edit_user', 'org_admin'],
        ui: {
            icon: ICONS.coi,
        },
    },
    component: Outlet,
});
